import React from 'react';
import PropTypes from 'prop-types';
import ReportingEngagementTable from './Charts/ReportingEngagementTable';
import ReportQualification from './Charts/ReportQualification';
import ReportReadiness from './Charts/ReportReadiness';
import ReportCompletionStatus from './Charts/ReportCompletionStatus';

const Reporting = (props) => {
	const {engagementMetrics} = props;

	return (
		<>
			<ReportReadiness engagementMetrics={engagementMetrics} />
			<ReportQualification engagementMetrics={engagementMetrics} />
			<ReportCompletionStatus engagementMetrics={engagementMetrics} />
			<ReportingEngagementTable engagementMetrics={engagementMetrics} />
		</>
	);
};

Reporting.defaultProps = {
	engagementMetrics: []
};

Reporting.propTypes = {
	engagementMetrics: PropTypes.arrayOf(
		PropTypes.shape({
			cRAccepted: PropTypes.number,
			cRDue3: PropTypes.number,
			cRDue5: PropTypes.number,
			cRDue10: PropTypes.number,
			cRDue30: PropTypes.number,
			cRDueTom: PropTypes.number,
			cRNotSent: PropTypes.number,
			cROD: PropTypes.number,
			cRPendResp: PropTypes.number,
			cRReceived: PropTypes.number,
			cRRetrn: PropTypes.number,
			cRTotal: PropTypes.number,
			cTComplSend: PropTypes.number,
			cTNotSent: PropTypes.number,
			cTOD: PropTypes.number,
			cTPartialSend: PropTypes.number,
			cTRetrn: PropTypes.number,
			cTTotal: PropTypes.number,
			cTUnlinkTot: PropTypes.number,
			conTaskClo: PropTypes.number,
			conTaskInProg: PropTypes.number,
			conTaskInRev: PropTypes.number,
			conTaskOpen: PropTypes.number,
			conTaskTotal: PropTypes.number,
			conTested: PropTypes.number,
			conTotal: PropTypes.number,
			defDesign: PropTypes.number,
			defOper: PropTypes.number,
			defOperAndDes: PropTypes.number,
			engDes: PropTypes.string,
			engId: PropTypes.number,
			engKey: PropTypes.number,
			gAType: PropTypes.number,
			hasAPEQRSO: PropTypes.bool,
			hasAPPICSO: PropTypes.bool,
			hasCRAEQRSO: PropTypes.bool,
			hasCRAPICSO: PropTypes.bool,
			isEQRCRASODlyd: PropTypes.bool,
			isEQREng: PropTypes.bool,
			isEQRInv: PropTypes.bool,
			isPartAPSODlyd: PropTypes.bool,
			isPartCRASODlyd: PropTypes.bool,
			isPartInvDlyd: PropTypes.bool
		})
	)
};

export default Reporting;
